import React from "react"
import Layout from "../components/layout/layout"
import Header from "../components/o-nas/Header"
import AboutUs from "../components/o-nas/AboutUs"
import OurSuperpowers from "../components/o-nas/OurSuperpowers"
import Logos from "../components/o-nas/Logos"
import HowWeWork from "../components/o-nas/HowWeWork"
import Team from "../components/o-nas/Team"
import FAQ from "../components/o-nas/FAQ"
import Contact from "../components/index/Contact"
import SEO from "../components/layout/seo"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "animate.css/animate.min.css"

const AboutUsPage = () => {
  return (
    <Layout>
      <SEO
        title="O nas - kim jesteśmy i co robimy"
        description="Nis Media to agencja interaktywna kreująca lokalne marki. Tworzymy strony internetowe, sklepy a także profecjonalnie zajmujemy się reklamą i brandingiem."
        canonical="/o-nas"
      />
      <Header />
      <AboutUs />
      <OurSuperpowers />
      <Logos />
      <HowWeWork />
      <Team />
      <FAQ />
      <Contact />
    </Layout>
  )
}

export default AboutUsPage
